import { SaveOutlined } from '@ant-design/icons'
import { Row } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { showMessageError, showMessageSuccess } from 'src/helpers/functions'
import { useStore } from 'src/hooks'

/**
 * O "Note1" trong popup chi tiet viec — ghi chu cua admin/supporter.
 * Luu bang API /job/note1; server thay note1 doi se ban callback
 * `job.note1_updated` sang Zenith de cap nhat orders.note1 cua don.
 * Chi render cho admin/supporter va designer cua viec (cha tu kiem tra quyen).
 */
const MAX_LENGTH = 5000

const JobDetailNote1 = observer(() => {
   const { t } = useTranslation()
   const JobDetailStore = useStore('JobDetailStore')
   const JobsStore = useStore('JobsStore')
   const { jobDetail } = JobDetailStore
   const [isSaving, setIsSaving] = useState(false)
   const isDirty = JobDetailStore.isFieldDirty('note1')

   const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      JobDetailStore.markFieldDirty('note1')
      JobDetailStore.setJobDetailNote1(e.target.value)
   }

   const handleSave = async () => {
      const note1 = (jobDetail?.note1 || '').trim()
      try {
         setIsSaving(true)
         const response = await JobDetailStore.updateNote1(jobDetail?.id, note1)
         if (!response) return
         // Va lai dong tuong ung ngoai bang quan ly viec de khong phai tai lai trang
         JobsStore.action_patchJobRow(jobDetail?.id, { note1 })
         showMessageSuccess('Đã cập nhật')
      } catch (error) {
         showMessageError(error)
      } finally {
         setIsSaving(false)
      }
   }

   return (
      <>
         <Row className="gx-flex-row gx-align-items-center gx-justify-content-between gx-mb-2 gx-mx-1" wrap={false}>
            <h4 style={{ fontSize: 14, fontWeight: 600, lineHeight: '22px', color: '#272944' }}>
               {t(GLOBAL_CLIENT.note1)}
            </h4>
            {isDirty && (
               <div className="gx-module-logo gx-mb-2" onClick={isSaving ? undefined : handleSave}>
                  <SaveOutlined style={{ color: '#272944', marginLeft: 8 }} />
                  <div style={{ fontSize: 14, fontWeight: 400, lineHeight: '22px', color: '#272944', marginLeft: 8 }}>
                     {t(GLOBAL_CLIENT.save)}
                  </div>
               </div>
            )}
         </Row>
         <Row className="gx-flex-row gx-align-items-center gx-justify-content-start gx-mb-2 gx-mx-1" wrap={false}>
            <TextArea
               className="gx-mb-2 gx-w-100"
               bordered={true}
               value={jobDetail?.note1 || ''}
               placeholder={t(GLOBAL_CLIENT.nhapnote1)}
               autoSize={{ minRows: 2, maxRows: 10 }}
               onChange={handleChange}
               maxLength={MAX_LENGTH}
               showCount
            />
         </Row>
      </>
   )
})

export default JobDetailNote1
